export default __webpack_public_path__ + "static/media/member6.be2a77ad.jpg";